module.exports = __webpack_public_path__ + "static/1-b108ae168ad864bbb80e3b69b195aeb1.jpg";